import { CRUD } from "@/shared/components";
import {
  ConfigsListQuery,
  ConfigShowQuery,
  DeleteConfigsMutation,
  RestoreConfigsMutation,
} from "@/admin/entities/configs";
import { useConfigsManagement, type ConfigRow } from "../model";
import * as ConfigsSchemas from "../model/schemas";
import { createEditSchema } from "../model/schemas";
import { ConfigShowComponent } from "@/admin/features/configs";

export function Configs() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useConfigsManagement();

  return (
    <CRUD<ConfigRow>
      listQuery={ConfigsListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={ConfigsSchemas.filterSchema}
      createSchema={ConfigsSchemas.createSchema}
      editSchema={createEditSchema(ConfigShowComponent)}
      editQuery={ConfigShowQuery}
      deleteMutation={DeleteConfigsMutation}
      restoreMutation={RestoreConfigsMutation}
      texts={texts}
      persistFilters
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
